import React from 'react';

const About = () => {
    return (
        <div>
            <h2 className="text-primary my-5"> Tourism Of Sylhet</h2>
            <h5 className=""> An one stop Travel solution in Sylhet under one Roof .
                For any query, call us without any hesitation</h5>
            <h6 className=""> সিলেটে একমাত্র আমাদেরই রয়েছে ৪০০+ গেস্ট নিয়ে ট্যুরের অভিজ্ঞতা ।
                আপনার যেকোন কর্পোরেট  ট্যুরের জন্য আস্থা রাখুন আমাদের উপর  ।আপনার যেকোন ট্যুর নির্ভেজাল ভাবে গুছিয়ে দিবে TOS TOURISM
                অফিস: ২য় তলা ,শেখ সানাউল্লাহ জামে মসজিদ মার্কেট জিতু মিয়ার পয়েন্ট  সিলেট
                01725 843030 , 01842 823030
                #tos_এর_সাথে_ঘুরুন
                #tos_এর_সাথে_ঘুরুন #TOS #Sylhet #corporate_tour #tourism
            </h6>
        </div>
    );
};

export default About;